import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { FiDialogsContentBase } from '@fi-shared/fi-dialogs/fi-dialogs-content-base';
import { IUserProfile } from '@fi-shared/profile-icon/profile-icon.component';

export interface IAutomatedActionSharingItemsListData {
    Name: string;
    ProfileData?: IUserProfile;
}

@Component({
    selector: 'fi-automated-action-sharing-items-list-dialog',
    template: `
        @if (data) {
            @if (isCommonStringList(data)) {
                @for (item of data; track $index) {
                    <p>{{ item }}</p>
                }
            } @else {
                <fi-automated-action-sharing-items-list [items]="data" />
            }
        }
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-checkpoint-action-sharing-items-list-dialog' },
    standalone: false,
})
export class FiAutomatedActionSharingItemsListDialogComponent extends FiDialogsContentBase<
    IAutomatedActionSharingItemsListData[] | string[],
    void
> {
    protected isCommonStringList(items: IAutomatedActionSharingItemsListData[] | string[]): items is string[] {
        return items.every((item) => typeof item === 'string');
    }
}
